import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
import * as _ from 'lodash';
import SearchBox from 'components/general/SearchBox';
import { ACCESS_REPORT, DOWNLOAD_ACCESS_REPORT } from 'actions/dataReport';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment-timezone';
import AdminHeader from 'components/header';
import LayoutContainer from 'components/layout/LayoutContainer';
import Card from 'components/inputs/Card';
import Button from 'components/inputs/Button';
import { IoSearchOutline } from 'react-icons/io5';
import { BsDownload } from 'react-icons/bs';
import DateTimePicker from 'components/inputs/DateTimePicker';
import { BiSort } from 'react-icons/bi';
import ReactPagination from 'components/general/ReactPagination';
import fileDownload from 'js-file-download';
import { MdRefresh } from 'react-icons/md';
import { Form, Formik } from 'formik';
import Select from 'components/inputs/Select';
import OffCanvas from 'components/inputs/OffCanvas';
import { FETCH_CHARGING_STATION } from 'actions/chargingStation';
import { FETCH_USER } from 'actions/user';
import { toast } from 'react-toastify';
import { FETCH_VEHICLE_MAKE } from 'actions/vehicleMake';
import { REPORT_RECORD_LIMIT_OPTIONS, REPORT_RECORD_LIMIT_SELECT_WIDTH, UPDATE_STATUS_CODE } from 'components/common/constant';
import { resolveReportLimit } from 'components/common/utils';

const AccessReport = () => {
  const dispatch = useDispatch();
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [searchText, setSearchText] = useState('');
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [startDate, setStartDate] = useState(moment().tz('Asia/Dubai').startOf('day'));
  const [endDate, setEndDate] = useState(moment(new Date()).tz('Asia/Dubai').endOf('day'));
  const [showAdvanceFilterPopup, setShowAdvanceFilterPopup] = useState(false);
  const [advanceFilterData, setAdvanceFilterData] = useState({});
  const [selectedOption, setSelectedOption] = useState('excel');
  const reportFormats = [
    { label: 'PDF Format', value: 'pdf' },
    { label: 'Excel Sheet', value: 'excel' },
  ];

  const accessReportList = useSelector((state) => state.accessReport.accessReport.results);
  const isLoader = useSelector((state) => state.accessReport.isLoading);
  const page = useSelector((state) => state.accessReport.accessReport.page);
  const totalData = useSelector((state) => state.accessReport.accessReport.totalResults);
  const limit = useSelector((state) => state.accessReport.accessReport.limit);
  const totalPages = useSelector((state) => state.accessReport.accessReport.totalPages);
  const profileData = useSelector((state) => state.profile.userProfile);
  const userProfileStations = profileData.charging_stations;
  const role = useSelector((state) => state.profile.userProfile.role);
  const isLoading = useSelector((state) => state.downloadingLoader.isLoading);
  const hasData = accessReportList && accessReportList.length > 0;

  const recordsLimitRef = useRef(limit);

  const accessReport = useCallback(
    (value) => {
      const lim = resolveReportLimit(value, recordsLimitRef.current);
      if (searchText) {
        const accessReportData = {
          ...value,
          from: moment(startDate).tz('Asia/Dubai').utc(),
          to: moment(endDate).tz('Asia/Dubai').utc(),
          search: searchText,
          sortBy: value?.sortBy || '-booking_stop',
          limit: lim,
        };
        dispatch({
          type: ACCESS_REPORT,
          payload: accessReportData,
          cb: (res) => {
            if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
              onCloseAdvanceFilterPopup();
            }
          },
        });
      } else if (!_.isEmpty(userProfileStations)) {
        const data = {
          ...value,
          from: moment(startDate).tz('Asia/Dubai').utc(),
          to: moment(endDate).tz('Asia/Dubai').utc(),
          charging_station: userProfileStations,
          limit: lim,
        };
        dispatch({
          type: ACCESS_REPORT,
          payload: data,
          cb: (res) => {
            if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
              onCloseAdvanceFilterPopup();
            }
          },
        });
      } else {
        const data = {
          ...value,
          from: moment(startDate).tz('Asia/Dubai').utc(),
          to: moment(endDate).tz('Asia/Dubai').utc(),
          sortBy: value?.sortBy || '-booking_stop',
          limit: lim,
        };
        dispatch({
          type: ACCESS_REPORT,
          payload: data,
          cb: (res) => {
            if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
              onCloseAdvanceFilterPopup();
            }
          },
        });
      }
    },
    [startDate, endDate, searchText]
  );

  const downloadaccessReport = useCallback(() => {
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);

    const startMonth = startMoment.month();
    const startYear = startMoment.year();
    const endMonth = endMoment.month();
    const endYear = endMoment.year();

    if (startMonth === endMonth && startYear === endYear) {
      const daysInMonth = startMoment.daysInMonth();
      const diffInDays = endMoment.diff(startMoment, 'days');

      if (diffInDays >= daysInMonth) {
        toast.error(`The date range exceeds ${daysInMonth} days. Please select a shorter range or download from Download Advance Report.`);
        return false;
      }
    } else {
      const startMonthDays = startMoment.daysInMonth();
      const remainingDaysInStartMonth = startMonthDays - startMoment.date() + 1;
      const daysInEndMonth = endMoment.date();

      const totalDays = remainingDaysInStartMonth + daysInEndMonth;

      if (totalDays > startMonthDays) {
        toast.error('The selected date range exceeds the allowed days. Please select a shorter range or download from Download Advance Report.');
        return false;
      }
    }
    if (!_.isEmpty(advanceFilterData)) {
      const data = {
        ...advanceFilterData,
        // excel: true,
        reportFormat: selectedOption,
        from: moment(startDate).tz('Asia/Dubai').utc(),
        to: moment(endDate).tz('Asia/Dubai').utc(),
      };
      dispatch({
        type: DOWNLOAD_ACCESS_REPORT,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200) {
              if (role === 'doco') {
                fileDownload(res.data, `Charging Sessions Report.${data.reportFormat === 'excel' ? 'xlsx' : 'pdf'}`);
              } else {
                fileDownload(res.data, `Partner Charging Sessions Report.${data.reportFormat === 'excel' ? 'xlsx' : 'pdf'}`);
              }
            }
          }
        },
      });
    } else if (_.isEmpty(advanceFilterData.charging_station) && !_.isEmpty(userProfileStations)) {
      const data = {
        from: moment(startDate).tz('Asia/Dubai').utc(),
        to: moment(endDate).tz('Asia/Dubai').utc(),
        charging_station: userProfileStations,
      };
      dispatch({
        type: DOWNLOAD_ACCESS_REPORT,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200) {
              if (role === 'doco') {
                fileDownload(res.data, `Charging Sessions Report.${data.reportFormat === 'excel' ? 'xlsx' : 'pdf'}`);
              } else {
                fileDownload(res.data, `Partner Charging Sessions Report.${data.reportFormat === 'excel' ? 'xlsx' : 'pdf'}`);
              }
            }
          }
        },
      });
    } else if (searchText) {
      const data = {
        // excel: true,
        reportFormat: selectedOption,
        from: moment(startDate).tz('Asia/Dubai').utc(),
        to: moment(endDate).tz('Asia/Dubai').utc(),
        search: searchText,
      };
      dispatch({
        type: DOWNLOAD_ACCESS_REPORT,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200) {
              if (role === 'doco') {
                fileDownload(res.data, `Charging Sessions Report.${data.reportFormat === 'excel' ? 'xlsx' : 'pdf'}`);
              } else {
                fileDownload(res.data, `Partner Charging Sessions Report.${data.reportFormat === 'excel' ? 'xlsx' : 'pdf'}`);
              }
            }
          }
        },
      });
    } else {
      const data = {
        // excel: true,
        reportFormat: selectedOption,
        from: moment(startDate).tz('Asia/Dubai').utc(),
        to: moment(endDate).tz('Asia/Dubai').utc(),
      };
      dispatch({
        type: DOWNLOAD_ACCESS_REPORT,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200) {
              if (role === 'doco') {
                fileDownload(res.data, `Charging Sessions Report.${data.reportFormat === 'excel' ? 'xlsx' : 'pdf'}`);
              } else {
                fileDownload(res.data, `Partner Charging Sessions Report.${data.reportFormat === 'excel' ? 'xlsx' : 'pdf'}`);
              }
            }
          }
        },
      });
    }
  }, [startDate, endDate, advanceFilterData, selectedOption, searchText]);

  const downloadFile = () => {
    downloadaccessReport();
  };

  useEffect(() => {
    accessReport();
  }, []);

  const dateFilter = useCallback(() => {
    if (sortByItem.item && sortByItem.order) {
      const filterDateData = {
        from: moment(startDate).tz('Asia/Dubai').utc(),
        to: moment(endDate).tz('Asia/Dubai').utc(),
      };
      getSortByItem(sortByItem.item, sortByItem.order, '', filterDateData);
    } else if (!_.isEmpty(advanceFilterData)) {
      const data = {
        ...advanceFilterData,
        from: moment(startDate).tz('Asia/Dubai').utc(),
        to: moment(endDate).tz('Asia/Dubai').utc(),
      };
      accessReport(data);
    } else {
      if (searchText) {
        const filterSearchData = {
          from: moment(startDate).tz('Asia/Dubai').utc(),
          to: moment(endDate).tz('Asia/Dubai').utc(),
          search: searchText,
        };
        accessReport(filterSearchData);
      } else {
        const filterDateData = {
          from: moment(startDate).tz('Asia/Dubai').utc(),
          to: moment(endDate).tz('Asia/Dubai').utc(),
        };
        accessReport(filterDateData);
      }
    }
  }, [startDate, endDate, sortByItem, searchText, advanceFilterData]);

  const searchHandler = (event) => {
    const value = event.target.value;
    setSearchText(value);
  };

  const getSortByItem = useCallback(
    (name, order, page, filterDateData) => {
      const sortedOrder = order || 'asc';
      if (page && startDate && endDate) {
        const data = {
          from: moment(startDate).tz('Asia/Dubai').utc(),
          to: moment(endDate).tz('Asia/Dubai').utc(),
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
          page: page.selected + 1,
        };
        endDate && accessReport(data);
      } else if (page) {
        const data = {
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
          page: page.selected + 1,
        };
        accessReport(data);
      } else if (filterDateData) {
        const data = {
          ...filterDateData,
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        };
        endDate && accessReport(data);
      } else {
        const data = {
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        };
        accessReport(data);
      }
    },
    [startDate, endDate]
  );

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else if (startDate && endDate && searchText) {
        const data = {
          from: moment(startDate).tz('Asia/Dubai').utc(),
          to: moment(endDate).tz('Asia/Dubai').utc(),
          search: searchText,
          page: page.selected + 1,
        };
        accessReport(data);
      } else if (startDate && endDate && !_.isEmpty(advanceFilterData)) {
        const data = {
          ...advanceFilterData,
          from: moment(startDate).tz('Asia/Dubai').utc(),
          to: moment(endDate).tz('Asia/Dubai').utc(),
          page: page.selected + 1,
        };
        accessReport(data);
      } else if (startDate && endDate) {
        const data = {
          from: moment(startDate).tz('Asia/Dubai').utc(),
          to: moment(endDate).tz('Asia/Dubai').utc(),
          page: page.selected + 1,
        };
        accessReport(data);
      } else {
        const data = {
          page: page.selected + 1,
        };
        accessReport(data);
      }
    },
    [sortByItem, startDate, endDate, searchText, advanceFilterData]
  );

  const onCloseAdvanceFilterPopup = () => setShowAdvanceFilterPopup(false);
  const handleAdvanceFilterData = (data) => setAdvanceFilterData(data);
  const allStation = useSelector((state) => state?.chargingStation?.chargingStations);
  const allUsers = useSelector((state) => state.user.users);
  const allVehicleMake = useSelector((state) => state.vehicleMake.vehicleMakes);

  const initialValues = !_.isEmpty(advanceFilterData) ? { ...advanceFilterData } : { company: '', charging_station: '', make: '' };

  const getAllStation = useCallback((data = {}) => {
    const stationData = {
      ...data,
      request_all: true,
    };
    dispatch({ type: FETCH_CHARGING_STATION, payload: stationData });
  }, []);

  const getAllUsers = useCallback((data) => {
    dispatch({
      type: FETCH_USER,
      payload: data ? data : null,
    });
  }, []);

  const getAllVehicleMake = useCallback((data = {}) => {
    dispatch({ type: FETCH_VEHICLE_MAKE, payload: data });
  }, []);

  useEffect(() => {
    getAllStation();
    getAllUsers({ role: 'doco', limit: 9999 });
    getAllVehicleMake({ limit: 999 });
  }, []);

  const search = <SearchBox preIcon={<BsSearch />} value={searchText} onChange={searchHandler} />;
  const searchIcon = <IoSearchOutline size={27} onClick={() => setShowSearchBar(true)} className="report-search-icon" />;

  return (
    <>
      <LayoutContainer>
        <AdminHeader title={`${role === 'doco' ? 'Charging Sessions' : 'Partner Charging Sessions'}`} />
        <div className="page-content-wrapper scrollable">
          <div className="data-report--main">
            <Card>
              <div className="data-report__inner">
                <div className="data-report__box">
                  <Row className="data-report__row">
                    <Col
                      xl={`${showSearchBar ? 'auto' : 'auto'}`}
                      md={`${showSearchBar ? 'auto' : 'auto'}`}
                      className={`${showSearchBar ? '' : 'data-report-search-box'}`}
                    >
                      {showSearchBar ? search : searchIcon}
                    </Col>
                    <Col xl={`${showSearchBar ? 'auto' : 'auto'}`} md={`${showSearchBar ? 'auto' : 'auto'}`}>
                      <div className="data-report-date_picker">
                        <DateTimePicker
                          onChangeOfStartDate={(item) => setStartDate(item)}
                          onChangeOfEndDate={(item) => setEndDate(item)}
                          initialValueOfStartDate={startDate}
                          initialValueOfEndDate={endDate}
                        />
                      </div>
                    </Col>
                    <Col xl={'auto'} md={'auto'}>
                      <div className="report-search-box" onClick={dateFilter}>
                        <Button className="report-search-button">Search</Button>
                      </div>
                    </Col>
                    <Col xl={'auto'} md={'auto'}>
                      <div className="report-search-excel-block">
                        <div className="advance-filter-btn" onClick={() => setShowAdvanceFilterPopup(true)}>
                          <Button className="report-search-button">Advance Filter</Button>
                        </div>
                      </div>
                    </Col>
                    <Col xl={2} md={'auto'}>
                      <Select
                        isDisabled={true}
                        options={reportFormats}
                        value={selectedOption}
                        onChange={(value) => setSelectedOption(value)}
                        placeholder="Select Report Format"
                      />
                    </Col>
                    <Col xl={'auto'} md={'auto'} className="excel-icon--block" onClick={hasData ? downloadFile : null}>
                      {isLoading ? (
                        <div className="loader--block">
                          <Spinner as="span" animation="border" size="sm" role="status" />
                        </div>
                      ) : (
                        <div className={`report-excel-icon  ${!hasData ? 'disabled' : ''}`}>
                          <BsDownload title={!hasData ? '' : 'Download'} size={28} color={!hasData ? '#d3d3d3' : '#3c7cdd'} />
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
                <div className="data-report__table">
                  <div className="table-responsive">
                    <table className="record-list-table" id="table-to-xls">
                      <thead>
                        <tr>
                          <th>
                            <div className="sorting">
                              <span>Sr No.</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Charger ID</span>
                              <span className="ico" onClick={() => handleSorting('charger_id', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Station Code</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Company Name</span>
                              <span className="ico" onClick={() => handleSorting('company', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Transaction Reference</span>
                              <span className="ico" onClick={() => handleSorting('mac', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Vehicle MAC</span>
                              <span className="ico" onClick={() => handleSorting('mac', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Vehicle Registration No.</span>
                              <span className="ico" onClick={() => handleSorting('vin_num', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Vehicle Plate Number</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Brand</span>
                              <span className="ico" onClick={() => handleSorting('make', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Start Date & Time</span>
                              <span className="ico" onClick={() => handleSorting('booking_start', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Stop Date & Time</span>
                              <span className="ico" onClick={() => handleSorting('booking_stop', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Booking Status</span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Unit Consumed (kWh)</span>
                              <span className="ico" onClick={() => handleSorting('units_consumed', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span> Basic Amount (AED)</span>
                              <span className="ico" onClick={() => handleSorting('basic_amount', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>VAT (AED)</span>
                              <span className="ico" onClick={() => handleSorting('vat', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Gross Amount (AED)</span>
                              <span className="ico" onClick={() => handleSorting('total_amount', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>PLU</span>
                              <span className="ico" onClick={() => handleSorting('PLU', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                          <th>
                            <div className="sorting">
                              <span>Total Charging Duration (HH:MM:SS)</span>
                              <span className="ico" onClick={() => handleSorting('total_duration', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoader ? (
                          <tr>
                            <td colSpan={9} className="border-0">
                              <div className="loader--block">
                                <Spinner as="span" animation="border" size="sm" role="status" />
                                <span className="ps-2">Loading...</span>
                              </div>
                            </td>
                          </tr>
                        ) : _.isEmpty(accessReportList) ? (
                          <tr>
                            {role == 'doco' ? (
                              <td colSpan={10} className="border-0">
                                <div className="empty-data-block">No Charging Session Report Found</div>
                              </td>
                            ) : (
                              <td colSpan={10} className="border-0">
                                <div className="empty-data-block">No Partner Charging Session Report Found</div>
                              </td>
                            )}
                          </tr>
                        ) : (
                          !(isLoader || _.isUndefined(isLoader)) &&
                          _.map(accessReportList, (item, key) => {
                            const serial_num = limit * (page - 1) + key;

                            return (
                              <>
                                <tr key={`access-report-${serial_num}`}>
                                  <td>{serial_num + 1}</td>
                                  <td>{_.get(item, 'ocpp_id', '-')}</td>
                                  <td>{_.get(item, 'station_code', '-')}</td>
                                  <td>{_.get(item, 'company', '-')}</td>
                                  <td>{_.get(item, 'transactionId', '-')}</td>
                                  <td>{_.get(item, 'mac', '-')}</td>
                                  <td>{_.get(item, 'vin_num', '-')}</td>
                                  <td>{_.get(item, 'plate_number', '-')}</td>
                                  <td>{_.get(item, 'make', '-')}</td>
                                  <td>{`${_.get(item, 'booking_start_date', '')}  ${_.get(item, 'booking_start_time', '')}`}</td>
                                  <td>{`${_.get(item, 'booking_stop_date', '')}  ${_.get(item, 'booking_stop_time', '')}`}</td>
                                  <td>{_.get(item, 'status', '-')}</td>
                                  <td>{_.get(item, 'units_consumed', '-')}</td>
                                  <td>{_.get(item, 'basic_amount', '-')}</td>
                                  <td>{_.get(item, 'vat', '-')}</td>
                                  <td>{_.get(item, 'total_amount', '-')}</td>
                                  <td>{_.get(item, 'PLU', '-')}</td>
                                  <td>{!_.isEmpty(_.get(item, 'duration')) ? _.get(item, 'duration') : '-'}</td>
                                </tr>
                              </>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(accessReportList) && (
                  <Row className="align-items-end mt-2 gx-3 flex-wrap">
                    <Col xs={12} md className="mb-2 mb-md-0">
                      <ReactPagination
                        currentPage={page}
                        limit={limit}
                        total={totalData}
                        handlePageClick={(pageVal) => handlePageClick(pageVal)}
                        totalPages={totalPages}
                        marginPagesDisplayed={1}
                      />
                    </Col>
                    <Col xs={12} md="auto">
                      <Select
                        label="Records"
                        width={REPORT_RECORD_LIMIT_SELECT_WIDTH}
                        options={REPORT_RECORD_LIMIT_OPTIONS}
                        value={limit}
                        onChange={(value) => {
                          const n = Number(value);
                          recordsLimitRef.current = n;
                          accessReport({ page: 1, limit: n });
                        }}
                        placeholder="Per page"
                      />
                    </Col>
                  </Row>
                )}
              </div>
            </Card>
          </div>
        </div>
      </LayoutContainer>

      {/* Report Advance Filter Functionality */}

      {showAdvanceFilterPopup && (
        <OffCanvas show={showAdvanceFilterPopup} onClose={onCloseAdvanceFilterPopup}>
          <Formik
            enableReinitialize={!_.isEmpty(advanceFilterData)}
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
              !values.company && delete values['company'];
              !values.make && delete values['make'];
              !values.charging_station && delete values['charging_station'];
              accessReport(values);
              handleAdvanceFilterData(values);
              onCloseAdvanceFilterPopup();
              setSubmitting(false);
            }}
          >
            {({ values, handleSubmit, setFieldValue, resetForm }) => (
              <Form onSubmit={handleSubmit}>
                <div className="mb-5">
                  <div className="canvas-selection__block">
                    <Select
                      label="Company"
                      options={_.map(allUsers, (item) => {
                        return { label: item.company, value: item.id };
                      })}
                      placeholder="Select Company"
                      name="company"
                      value={values.company}
                      onMenuScrollDown={true}
                      onChange={(val) => {
                        setFieldValue(`company`, val);
                      }}
                    />
                    <Select
                      label="Vehicle Brand"
                      options={_.map(allVehicleMake, (item) => {
                        return { label: item.name, value: item.name };
                      })}
                      placeholder="Select Vehicle Brand"
                      name="make"
                      value={values.make}
                      onMenuScrollDown={true}
                      onChange={(val) => {
                        setFieldValue(`make`, val);
                      }}
                    />
                    <Select
                      label="Station"
                      options={
                        !_.isEmpty(allStation) && [
                          ..._.map(allStation, (station) => {
                            return { label: station.name, value: station.id };
                          }),
                        ]
                      }
                      placeholder="Select Station"
                      name="charging_station"
                      isMulti
                      value={values.charging_station}
                      onMenuScrollDown={true}
                      onChange={(val) => {
                        setFieldValue('charging_station', val);
                      }}
                    />
                  </div>
                </div>
                <div className="canvas-btn__block">
                  <Button type="submit" className="apply--btn w-100">
                    Apply Filters
                  </Button>
                  <div
                    className="reset--block"
                    onClick={() => {
                      setAdvanceFilterData({});
                      accessReport();
                      resetForm();
                      onCloseAdvanceFilterPopup();
                    }}
                  >
                    <MdRefresh size={24} className="reset--icon" />
                    Reset
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </OffCanvas>
      )}
    </>
  );
};

export default AccessReport;
